const animatedNumberInit = (block) => {
    const counters = block ? [block[0].querySelector(".bn-animated-number__number")] : Array.from(document.querySelectorAll('.bn-animated-number__number'));

    if (counters) {
        counters.forEach(counter => {
            if (counter) {
                const counterValue = parseInt(counter.dataset.number);

                const startCounting = () => {
                    let count = 0;

                    const countingInterval = setInterval(() => {
                        if (count < counterValue) {
                            count++;
                            counter.textContent = count;
                        } else {
                            clearInterval(countingInterval);
                        }
                    }, 100);
                };

                const observer = new IntersectionObserver(entries => {
                    if (entries[0].isIntersecting) {
                        startCounting();
                        observer.disconnect();
                    }
                });
                observer.observe(counter);
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body'))
        animatedNumberInit();
    else if (window.acf)
        window.acf.addAction('render_block_preview/type=bn/animated-number', animatedNumberInit);
});